import _ from 'lodash';
import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Store, StoreModule } from '@ngrx/store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { selectUser } from 'app/signup/features/data/data.selectors';
import { CommonModule } from '@angular/common';
import { NgxPlaidLinkModule } from 'ngx-plaid-link';

@Component({
  selector: 'app-ngx-plaid-link-wrapper',
  templateUrl: './ngx-plaid-link-wrapper.component.html',
  styleUrls: ['./ngx-plaid-link-wrapper.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NgxPlaidLinkModule
  ]
})
export class NgxPlaidLinkWrapperComponent implements OnInit {

  @Input() plaid: any = null;

  @Output() Success: EventEmitter<any> = new EventEmitter();
  @Output() Exit: EventEmitter<any> = new EventEmitter();
  @Output() Load: EventEmitter<any> = new EventEmitter();
  @Output() Event: EventEmitter<any> = new EventEmitter();
  @Output() Click: EventEmitter<any> = new EventEmitter();

  private destroyRef = inject(DestroyRef);

  public token: string = null;

  constructor(
    private store: Store
  ) { }

  ngOnInit(): void {
    this.store.select(selectUser).pipe(
      filter(user => !_.isNull(user)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((user) => {
      window['api'].getPlaidToken(
        user.email,
        user.name,
        window['orgSignIn'].getAccessToken(),
        (token) => {
          this.token = token;
        }
      )
    });
  }

  onPlaidSuccess(event) {
    this.Success.emit(event);
  }

  onPlaidExit(event) {
    this.Exit.emit(event);
  }

  onPlaidLoad(event) {
    this.Load.emit(event);
  }

  onPlaidEvent(event) {
    this.Event.emit(event);
  }

  onPlaidClick(event) {
    this.Click.emit(event);
  }

}
